import * as React from "react";
import { connect } from "react-redux";
import { IdResource } from "../../constants/IdResource";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { ButtonAddResource } from "../generic/common/ButtonAddResource";
import { actionInventoryInfoRequestAddResource } from "../info/inventory/actionInventoryInfo";
var _ButtonDogTreatAddResource = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(Badge, { position: IdBadgePosition.Right },
        React.createElement(ButtonAddResource, { className: "resource-add-button", onClick: onClick })));
};
var mapDispatch = function (dispatch) { return ({
    onClick: function () { return dispatch(actionInventoryInfoRequestAddResource(IdResource.DogtreatPremium)); },
}); };
export var ButtonDogTreatAddResource = connect(undefined, mapDispatch)(_ButtonDogTreatAddResource);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/ButtonDogTreatAddResource.tsx
// module id = 924
// module chunks = 3